import { ComboBox, DatePicker, DayOfWeek, DefaultButton, defaultDatePickerStrings, Dialog, DialogFooter, DialogType, Icon, IconButton, IPersonaProps, IPickerItemProps, IStackTokens, ISuggestionItemProps, ISuggestionModel, ISuggestionsProps, ITag, Label, MessageBar, MessageBarType, Modal, NormalPeoplePicker, PeoplePickerItem, Persona, PersonaSize, Pivot, PivotItem, PrimaryButton, Separator, Spinner, SpinnerSize, Stack, TagItemSuggestion, TagPicker, Text, TextField, Toggle, TooltipHost, ValidationState, values } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../../app/Hooks";
import * as Yup from 'yup';
import { DynamicInputField, InputField } from "../../../controls/Controls";
import { inputs } from "../../../../../app/Validation";
import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../../app/Api";
import { Message } from "../../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../../FormProps";
import { BoolValue, Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatDate, timestampToDate, toFixedWithoutRounding } from "../../../../../app/Helpers";
import { AuthenticateReply } from "../../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../../common/DynamicFields/DynamicFields";
import { ExtraField } from "../../../../../repository/Accountant/common_pb";
import { TableState } from "../../../../common/Table/TableSate";
import { AccountStatus, LimitationType, Operations, OrderAction } from "../../../../../app/Enums";
import { GetCurrenciesRequest } from "../../../../../repository/Accountant/currency_pb"
import { AddCurrencyPairRequest, GetCurrencyPairRequest, UpdateCurrencyPairResponse, AddCurrencyPairResponse, UpdateCurrencyPairRequest, GetCurrencyPairsRequest } from "../../../../../repository/Trading/currency_pair_pb";
import { List } from "../../../../common/List/List";
import { Popup } from "../../../../common/Popup/Popup";
import { CurrenciesPage } from "../../../../pages/Accountant/Currencies/CurrenciesPage";
import { GetCategoriesRequest } from "../../../../../repository/Trading/category_pb";
import { CurrencyPairsPage } from "../../../../pages/Trading/CurrencyPairs/CurrencyPairsPage";
import { CategoriesPage } from "../../../../pages/Trading/Categories/CategoriesPage";
import { BulkCancelationRequest, BulkCancelationResponse } from "../../../../../repository/Trading/order_pb";
import moment from "moment";
import { UsersPage } from "../../../../pages/Customers/Users/UsersPage";
import { GetUsersRequest } from "../../../../../repository/UserManagement/Customers/user_pb";
import { bulkCancel, dismissMessage, getClinetUsers, getCurrencyPairs, reset, resetCurrencyPairs, resetUsers, setIsFilteredClientsSet, setIsFilteredCurrencyPairsSet, setSelectedCurrencyPairItems, setSelectedUserItems } from "./BulkCancelationFormSlice";
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb";

let req: BulkCancelationRequest;
let currecyPairsReq: GetCurrencyPairsRequest;
let clintsReq: GetUsersRequest;

let promise: any;
let getFilterPromise: any;
let org: number = -1;
let current: AuthenticateReply.AsObject;

export const BulkCancelationForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();
    const [currentAction, setCurrenctAction] = useState(0)
    const [selectedKey, setSelectedKey] = useState(0);
    const onNextClick = () => {
        setSelectedKey((selectedKey + 1) % 2);
    };
    const onBackClick = () => {
        setSelectedKey((selectedKey - 1) % 2);
    };
    const modalPropsStyles = { main: { maxWidth: 450 } };
    const [isDraggable, { toggle: toggleIsDraggable }] = useBoolean(false);
    const modalProps = useMemo(
        () => ({
            isBlocking: true,
            styles: modalPropsStyles,
            dragOptions: undefined,
        }),
        [isDraggable],
    );
    const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
    const [showConfirmation, setShowConfirmation] = useState({
        type: DialogType.normal,
        title: '',
        subText: '',
    });

    const state: {
        isLoading: boolean, message: ApiMessage | undefined, stage1: any,
        currencyPairs: TableState,
        clients: TableState
    } = useAppSelector((state) => {

        return {
            isLoading: state.bulkCancelationForm.isLoading, message: state.bulkCancelationForm.message, stage1: state.bulkCancelationForm.stage1,
            currencyPairs: state.bulkCancelationForm.currencyPairs,
            clients: state.bulkCancelationForm.clients


        }
    })
    const fromDate = new Date();
    fromDate.setDate(fromDate.getDate() - 1);

    useEffect(() => {
        var l = searchParams.get('org');
        req = new BulkCancelationRequest()
        clintsReq = new GetUsersRequest();
        currecyPairsReq = new GetCurrencyPairsRequest();
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
                currecyPairsReq.setOrganization(wrapper)
                clintsReq.setOrganization(wrapper)

            }
        }
        const boolv = new BoolValue();
        boolv.setValue(true);
        const stat = new Int32Value();
        stat.setValue(AccountStatus.ACTIVE);

        currecyPairsReq.setNumofresults(state.currencyPairs.numberOfResults)
        currecyPairsReq.setOrder(state.currencyPairs.isDescending)
        currecyPairsReq.setIsactive(boolv)

        clintsReq.setNumofresults(state.clients.numberOfResults)
        clintsReq.setOrder(state.clients.isDescending)

        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            getFilterPromise?.abort();
            dispatch(reset());
        }
    }, [])

    const pairsSuggestionsProps: ISuggestionsProps<ITag> = {
        suggestionsHeaderText: t('pair'),
        noResultsFoundText: t('noResults'),
        loadingText: t('loading'),
        searchForMoreText: t('loadMore'),
        searchingText: t('pleaseWait'),
        searchForMoreIcon: { iconName: "more" },
        moreSuggestionsAvailable: state.currencyPairs.hasMore && !state.currencyPairs.isFetching,
        onRenderSuggestion: (props: ITag, suggestionItemProps: ISuggestionItemProps<ITag>) => {
            return <TagItemSuggestion>
                {props?.name ?? props?.key}
            </TagItemSuggestion>
        },
        onSuggestionClick: (ev?, item?: any, index?: number) => {
            var u = state.currencyPairs.items.findIndex(e => e.id == item.key)
            if (u >= 0) {
                dispatch(setSelectedCurrencyPairItems([state.currencyPairs.items.at(u)]))
            }

        },

        onGetMoreResults: () => {
            if (state.currencyPairs.items.length > 0 && !state.currencyPairs.isFetching) {
                const wrapper = new StringValue();
                wrapper.setValue(state.currencyPairs.items.at(state.currencyPairs.items.length - 1).id);
                currecyPairsReq.setNextto(wrapper)
                getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
            }
        },
        suggestions: state.currencyPairs.items.length > 0 ? state.currencyPairs.items.map(e => { return { item: { name: e.name, key: e.id } } as ISuggestionModel<ITag> }) : [],
        isLoading: state.currencyPairs.items.length == 0 ? state.currencyPairs.isFetching : false,
        isSearching: state.currencyPairs.items.length > 0 ? state.currencyPairs.isFetching : false,


    };
    const onPairsFilterChanged = (filterText: string, selectedItems?: ITag[]): ITag[] => {

        dispatch(resetCurrencyPairs())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        currecyPairsReq.setSearch(wrapper)
        currecyPairsReq.setNextto(undefined)
        dispatch(setIsFilteredCurrencyPairsSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
        return [];

    }

    const onOwnersFilterChanged = (filterText: string, selectedItems?: IPersonaProps[]): IPersonaProps[] => {

        dispatch(resetUsers())
        const wrapper = new StringValue();
        wrapper.setValue(filterText);
        clintsReq.setSearch(wrapper)
        clintsReq.setNextto(undefined)
        dispatch(setIsFilteredClientsSet(true))
        getFilterPromise?.abort();
        getFilterPromise = dispatch(getClinetUsers({ body: clintsReq, headers: getHeaders() }))
        return [];

    }

    return (
        <>
            <Popup isOpen={(currentAction == 100)} title={t("pair")} onDismiss={() => { setCurrenctAction(0) }} >

                <CurrencyPairsPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedCurrencyPairItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Popup isOpen={(currentAction == 101)} title={t("clients")} onDismiss={() => { setCurrenctAction(0) }} >

                <UsersPage isSelection={true} onItemSelected={(e) => {
                    dispatch(setSelectedUserItems([e]))
                    setCurrenctAction(0)
                }} onCancel={() => { setCurrenctAction(0) }} />

            </Popup>

            <Formik

                enableReinitialize={true}
                initialValues={{
                    currencyPairs: undefined,
                    client: undefined,
                    cancelationReason: undefined,
                    from: moment(fromDate, 'YYYY-MM-DD').startOf('day').toDate(),
                    to: moment(new Date(), 'YYYY-MM-DD').endOf('day').toDate(),
                    tradeAction: 0,
                    orderType: 0,
                    appearance: 0,
                    isPartiallyFilled: 0,
                    isQuantityMaxLimitReached: 0,
                    isQuantityMinLimitReached: 0,
                    isPriceMaxLimitReached: 0,
                    isPriceMinLimitReached: 0,
                    isPriceTickSizeViolated: 0,
                    isQuantityTickSizeViolated: 0,
                    isConfirmed: false


                }}

                validationSchema={Yup.object({
                    cancelationReason: inputs.note,

                })}

                onSubmit={(values, actions) => {
                    if (selectedKey == 0) {


                        onNextClick();
                        return;
                    }

                    if (props.type == FormType.ADD) {
                        let currencyPairs = state.currencyPairs.selected.at(0);
                        if (currencyPairs) {
                            let s = new StringValue();
                            s.setValue(currencyPairs.id)
                            req.setCurrencypair(s);
                        } else {
                            req.setCurrencypair(undefined);
                        }
                        let clinet = state.clients.selected.at(0);
                        if (clinet) {
                            let s = new StringValue();
                            s.setValue(clinet.internalId)
                            req.setClient(s);
                        } else {
                            req.setClient(undefined);

                        }

                        if (values.cancelationReason) {
                            let s = new StringValue();
                            s.setValue(values.cancelationReason)
                            req.setCancelationreason(s);
                        } else {
                            req.setCancelationreason(undefined);

                        }


                        if (values.from) {
                            const wrapper = new Timestamp();
                            wrapper.fromDate(moment(values.from, 'YYYY-MM-DD').startOf('day').toDate())
                            req.setFrom(wrapper)
                        } else {
                            req.setFrom(undefined);

                        }
                        if (values.to) {
                            const wrapperTo = new Timestamp();
                            wrapperTo.fromDate(moment(values.to, 'YYYY-MM-DD').endOf('day').toDate())
                            req.setTo(wrapperTo)
                        } else {
                            req.setTo(undefined);

                        }
                        if (values.tradeAction != 0) {
                            const wrapperTo = new Int32Value();
                            wrapperTo.setValue(values.tradeAction)
                            req.setTradeaction(wrapperTo)
                        } else {
                            req.setTradeaction(undefined);

                        }
                        if (values.appearance != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.appearance == 1)
                            req.setIsprivate(wrapperTo)
                        } else {
                            req.setIsprivate(undefined);

                        }
                        if (values.orderType != 0) {
                            const wrapperTo = new Int32Value();
                            wrapperTo.setValue(values.orderType)
                            req.setOrdertype(wrapperTo)
                        } else {
                            req.setOrdertype(undefined);

                        }
                        if (values.isPartiallyFilled != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isPartiallyFilled == 1 ? true : false)
                            req.setIspartiallyfilled(wrapperTo)
                        } else {
                            req.setIspartiallyfilled(undefined);

                        }
                        if (values.isQuantityMaxLimitReached != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isQuantityMaxLimitReached == 1 ? true : false)
                            req.setIsquantitymaxlimitreached(wrapperTo)
                        } else {
                            req.setIsquantitymaxlimitreached(undefined);

                        }
                        if (values.isQuantityMinLimitReached != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isQuantityMinLimitReached == 1 ? true : false)
                            req.setIsquantityminlimitreached(wrapperTo)
                        } else {
                            req.setIsquantityminlimitreached(undefined);
                        }
                        if (values.isPriceMaxLimitReached != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isPriceMaxLimitReached == 1 ? true : false)
                            req.setIspricemaxlimitreached(wrapperTo)
                        } else {
                            req.setIspricemaxlimitreached(undefined);
                        }
                        if (values.isPriceMinLimitReached != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isPriceMinLimitReached == 1 ? true : false)
                            req.setIspriceminlimitreached(wrapperTo)
                        } else {
                            req.setIspriceminlimitreached(undefined);
                        }

                        /*if (values.isPriceTickSizeViolated != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isPriceTickSizeViolated == 1 ? true : false)
                            req.setIspriceticksizeviolated(wrapperTo)
                        }else {
                            req.setIspriceticksizeviolated(undefined);
                        }
                        if (values.isQuantityTickSizeViolated != 0) {
                            const wrapperTo = new BoolValue();
                            wrapperTo.setValue(values.isQuantityTickSizeViolated == 1 ? true : false)
                            req.setIsquantityticksizeviolated(wrapperTo)
                        }else {
                            req.setIsquantityticksizeviolated(undefined);
                        }
*/
                        req.setDirectexecute(values.isConfirmed)


                        promise = dispatch(bulkCancel({ body: req, headers: getHeaders() }))
                        values.isConfirmed = false;
                        promise.unwrap()
                            .then((res: BulkCancelationResponse.AsObject) => {
                                if (res) {

                                    if (req.getDirectexecute()) {
                                        dispatch(resetCurrencyPairs())
                                        dispatch(resetUsers())
                                        actions.resetForm()
                                        onBackClick();


                                    } else {

                                        setShowConfirmation({
                                            type: DialogType.normal,
                                            title: t("confirm"),
                                            subText: t("cancelationCount", { count: res.success?.count?.value ?? 0 }),

                                        })
                                        toggleHideDialog()

                                    }

                                }
                                actions.setSubmitting(false)


                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    } else {

                    }
                }}

            >
                {formkikProps => (
                    <Form onSubmit={(e) => {
                        e.preventDefault()
                        if (props.type == FormType.ADD) {
                            formkikProps.validateForm().then(e => {
                                if (selectedKey == 0)
                                    onNextClick();
                                else formkikProps.submitForm();

                            });
                        } else {
                            formkikProps.submitForm();
                        }
                    }
                    }>
                        <Dialog
                            hidden={hideDialog}
                            onDismiss={toggleHideDialog}
                            dialogContentProps={showConfirmation}
                            modalProps={modalProps}
                        >

                            <DialogFooter>
                                <PrimaryButton autoFocus onClick={(e: any) => { formkikProps.setFieldValue("isConfirmed", true); formkikProps.handleSubmit(e); toggleHideDialog() }} text={t("cancelOrders")} type="submit" />
                                <DefaultButton onClick={toggleHideDialog} text={t("back")} />
                            </DialogFooter>
                        </Dialog>
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }

                            <Pivot selectedKey={String(selectedKey)} >
                                <PivotItem headerText={t("pairInfo")} itemKey="0" >

                                    <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >

                                        {props.type == FormType.ADD ? <Stack grow>
                                            <Label disabled={state.isLoading}>{t("pair")}</Label>
                                            <List
                                                inputProps={{ placeholder: t("pair"), }}
                                                disabled={state.isLoading}
                                                suggestionsHeaderText={t('pair')}
                                                isPeoplePicker={true}
                                                isLoading={state.currencyPairs.items.length == 0 ? state.currencyPairs.isFetching : false}
                                                isSearching={state.currencyPairs.items.length > 0 ? state.currencyPairs.isFetching : false}
                                                moreSuggestionsAvailable={state.currencyPairs.hasMore && !state.currencyPairs.isFetching}
                                                suggestions={state.currencyPairs.items.length > 0 ? state.currencyPairs.items.map(e => { return { item: { key: e.id, text: e.name, imageInitials: e?.baseCurrencySymbol + "/" + e?.quoteCurrencySymbol, secondaryText: (e?.baseCurrencyCode == "" ? e?.baseCurrencyId : e?.baseCurrencyCode) + "-" + (e?.quoteCurrencyCode == "" ? e?.quoteCurrencyId : e?.quoteCurrencyCode), imageUrl: e?.iconSource } } as ISuggestionModel<IPersonaProps> }) : []}
                                                onGetMoreResults={() => {
                                                    if (state.currencyPairs.items.length > 0 && !state.currencyPairs.isFetching) {
                                                        const wrapper = new StringValue();
                                                        wrapper.setValue(state.currencyPairs.items.at(state.currencyPairs.items.length - 1).id);
                                                        currecyPairsReq.setNextto(wrapper)
                                                        getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
                                                    }
                                                }}
                                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                                    var u = state.currencyPairs.items.findIndex(e => e.id == item.key)
                                                    if (u >= 0) {
                                                        dispatch(setSelectedCurrencyPairItems([state.currencyPairs.items.at(u)]))
                                                    }


                                                }}
                                                selectedItems={state.currencyPairs.selected.length > 0 ? state.currencyPairs.selected.map(e => { return { key: e.id, text: e.name, imageInitials: e?.baseCurrencySymbol + "/" + e?.quoteCurrencySymbol, secondaryText: (e?.baseCurrencyCode == "" ? e?.baseCurrencyId : e?.baseCurrencyCode) + "-" + (e?.quoteCurrencyCode == "" ? e?.quoteCurrencyId : e?.quoteCurrencyCode), imageUrl: e?.iconSource } as IPersonaProps }) : []}
                                                onChange={(e) => {
                                                    dispatch(setSelectedCurrencyPairItems([]))

                                                }}
                                                onEmptyInputFocus={() => {
                                                    dispatch(resetCurrencyPairs())
                                                    currecyPairsReq.setSearch(undefined)
                                                    currecyPairsReq.setNextto(undefined)

                                                    dispatch(setIsFilteredCurrencyPairsSet(false))
                                                    getFilterPromise?.abort()
                                                    getFilterPromise = dispatch(getCurrencyPairs({ body: currecyPairsReq, headers: getHeaders() }))
                                                    return []
                                                }}
                                                onFilterChanged={onPairsFilterChanged}
                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                            setCurrenctAction(100)

                                                        }
                                                    }]}
                                            />
                                        </Stack> : undefined}

                                        {props.type == FormType.ADD ? <Stack>

                                            <Label
                                                disabled={state.isLoading}>{t("clients")}</Label>
                                            <List
                                                isPeoplePicker={true}
                                                suggestionsHeaderText={t('clients')}
                                                isLoading={state.clients.items.length == 0 ? state.clients.isFetching : false}
                                                isSearching={state.clients.items.length > 0 ? state.clients.isFetching : false}
                                                moreSuggestionsAvailable={state.clients.hasMore && !state.clients.isFetching}
                                                suggestions={state.clients.items.length > 0 ? state.clients.items.map(e => { return { item: { key: e.internalId, text: e.name, secondaryText: e.username, imageUrl: e?.imageSource && e?.imagePath ? e?.imageSource + "" + e?.imagePath : undefined } } as ISuggestionModel<IPersonaProps> }) : []}
                                                onGetMoreResults={() => {
                                                    if (state.clients.items.length > 0 && !state.clients.isFetching) {
                                                        const wrapper = new StringValue();
                                                        wrapper.setValue(state.clients.items.at(state.clients.items.length - 1).internalId);
                                                        clintsReq.setNextto(wrapper)
                                                        getFilterPromise = dispatch(getClinetUsers({ body: clintsReq, headers: getHeaders() }))
                                                    }
                                                }}
                                                onSuggestionClick={(ev?, item?: any, index?: number) => {
                                                    var u = state.clients.items.findIndex(e => e.internalId == item.key)
                                                    if (u >= 0) {
                                                        dispatch(setSelectedUserItems([state.clients.items.at(u)]))
                                                    }

                                                }}
                                                inputProps={{ placeholder: t("clients"), }}

                                                disabled={state.isLoading}
                                                selectedItems={state.clients.selected.length > 0 ? state.clients.selected.map(e => { return { key: e.internalId, text: e.name, secondaryText: e.username, imageUrl: e?.imageSource && e?.imagePath ? e?.imageSource + "" + e?.imagePath : undefined } as IPersonaProps }) : []}
                                                onChange={(e) => {
                                                    dispatch(setSelectedUserItems([]))
                                                }}
                                                onEmptyInputFocus={() => {
                                                    dispatch(resetUsers())
                                                    clintsReq.setSearch(undefined)
                                                    clintsReq.setNextto(undefined)
                                                    dispatch(setIsFilteredClientsSet(false))
                                                    getFilterPromise?.abort()
                                                    getFilterPromise = dispatch(getClinetUsers({ body: clintsReq, headers: getHeaders() }))
                                                    return []

                                                }}
                                                onFilterChanged={onOwnersFilterChanged}
                                                endButtons={[
                                                    {
                                                        title: t("advancedOptions"), checked: true, iconProps: { iconName: "ShowResults" },
                                                        onClick: () => {
                                                            setCurrenctAction(100)

                                                        }
                                                    }]}
                                            />

                                        </Stack> : undefined}

                                        <DatePicker
                                            isRequired
                                            firstDayOfWeek={DayOfWeek.Sunday}
                                            label={t("from")}
                                            placeholder={t("from")}
                                            disabled={state.isLoading}
                                            value={formkikProps.values.from}
                                            ariaLabel={t("from")}
                                            formatDate={(e) => {
                                                return formatDate(e, 'YYYY-MM-DD')
                                            }}
                                            parseDateFromString={(date) => {
                                                return moment(date, 'YYYY-MM-DD').startOf('day').toDate();
                                            }}
                                            // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                            strings={defaultDatePickerStrings}
                                            onSelectDate={(date: Date | null | undefined) => {

                                                formkikProps.setFieldValue("from", date)
                                            }}

                                        />

                                        <DatePicker
                                            isRequired
                                            firstDayOfWeek={DayOfWeek.Sunday}
                                            label={t("to")}
                                            placeholder={t("to")}
                                            disabled={state.isLoading}
                                            value={formkikProps.values.to}
                                            ariaLabel={t("to")}
                                            formatDate={(e) => {
                                                return formatDate(e, 'YYYY-MM-DD')
                                            }}
                                            parseDateFromString={(date) => {
                                                return moment(date, 'YYYY-MM-DD').endOf('day').toDate();
                                            }}
                                            // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                            strings={defaultDatePickerStrings}
                                            onSelectDate={(date: Date | null | undefined) => {
                                                if (date != undefined)
                                                    if (moment(date).isSameOrAfter(formkikProps.values.from)) {
                                                        formkikProps.setFieldValue("to", date)
                                                    } else {
                                                        formkikProps.setFieldValue("to", new Date())
                                                    }
                                            }}

                                        />


                                        <Field name="cancelationReason" label={
                                            <div>
                                                {t("cancelationReason") + ' '}
                                                <TooltipHost content={t("cancelationReasonDesc")}>
                                                    <Icon iconName="Info" aria-label={t("cancelationReason")} />
                                                </TooltipHost>
                                            </div>
                                        } placeholder={t("cancelationReason")} component={InputField} rows={3} multiline resizable={false} disabled={state.isLoading} maxLength={140} />

                                    </Stack>
                                </PivotItem>
                                <PivotItem headerText={t("tradingSettings")} itemKey="1">

                                    <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >


                                        <ComboBox
                                            label={t("tradeAction")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: OrderAction.BUY, text: t("buy") }, { key: OrderAction.SELL, text: t("sell") },
                                            ]}
                                            selectedKey={formkikProps.values?.tradeAction}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`tradeAction`, o?.key)


                                            }}
                                        // Force re-creating the component when the toggles change (for demo purposes)
                                        />


                                        <ComboBox
                                            label={t("orderType")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 2, text: t("limitOrderInternal") }, { key: 3, text: t("limitOrderExternal") }, { key: 4, text: t("AON") }]}

                                            selectedKey={formkikProps.values?.orderType}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`orderType`, o?.key)

                                            }}
                                        />

                                        <ComboBox
                                            label={t("appearance")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("privateOrder") }, { key: 2, text: t("publicOrder") }]}

                                            selectedKey={formkikProps.values?.appearance}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {
                                                formkikProps.setFieldValue(`appearance`, o?.key)

                                            }}
                                        />
                                        <ComboBox
                                            label={t("isPartiallyFilled")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("yes") }, { key: 2, text: t("no") }]}

                                            selectedKey={formkikProps.values?.isPartiallyFilled}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {
                                                formkikProps.setFieldValue(`isPartiallyFilled`, o?.key)

                                            }}
                                        />


                                        <ComboBox
                                            label={t("isQuantityMaxLimitReached")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("yes") }, { key: 2, text: t("no") }]}

                                            selectedKey={formkikProps.values?.isQuantityMaxLimitReached}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isQuantityMaxLimitReached`, o?.key)

                                            }}
                                        />


                                        <ComboBox
                                            label={t("isQuantityMinLimitReached")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("yes") }, { key: 2, text: t("no") }]}

                                            selectedKey={formkikProps.values?.isQuantityMinLimitReached}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isQuantityMinLimitReached`, o?.key)

                                            }}
                                        />

                                        {/*
                                        <ComboBox
                                            label={t("isQuantityTickSizeViolated")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("yes") }, { key: 2, text: t("no") }]}

                                            selectedKey={formkikProps.values?.isPriceTickSizeViolated}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isQuantityTickSizeViolated`, o?.key)

                                            }}
                                        /> */}

                                        <ComboBox
                                            label={t("isPriceMaxLimitReached")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("yes") }, { key: 2, text: t("no") }]}

                                            selectedKey={formkikProps.values?.isPriceMaxLimitReached}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isPriceMaxLimitReached`, o?.key)

                                            }}
                                        />
                                        <ComboBox
                                            label={t("isPriceMinLimitReached")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("yes") }, { key: 2, text: t("no") }]}

                                            selectedKey={formkikProps.values?.isPriceMinLimitReached}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isPriceMinLimitReached`, o?.key)

                                            }}
                                        />
                                        {/*
                                        <ComboBox
                                            label={t("isPriceTickSizeViolated")}
                                            disabled={state.isLoading}
                                            options={[{ key: 0, text: t("unspecified") }, { key: 1, text: t("yes") }, { key: 2, text: t("no") }]}

                                            selectedKey={formkikProps.values?.isPriceTickSizeViolated}
                                            allowFreeInput={false}
                                            allowFreeform={false}
                                            onChange={(e, o) => {

                                                formkikProps.setFieldValue(`isPriceTickSizeViolated`, o?.key)

                                            }}
                                        />
*/}

                                    </Stack>




                                </PivotItem>


                            </Pivot>





                        </Stack>
                        <DialogFooter>
                            <PrimaryButton type="submit" disabled={state.isLoading} text={state.isLoading ? undefined : selectedKey == 0 ? t("next") : props.type == FormType.ADD ? t("confirm") : t("edit")} >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={selectedKey == 1 ? t("back") : props.type == FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (selectedKey == 1) {
                                    onBackClick();
                                    return;
                                }
                                if (props.onCancel) {

                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>



                    </Form>
                )}
            </Formik >
        </>
    );

}

